/* Progressive enhancement: all products and the collection link work without JavaScript. */
if (!customElements.get('rivonella-showcase')) {
  customElements.define('rivonella-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const grid = this.querySelector('[data-showcase-grid]');
      const button = this.querySelector('[data-showcase-expand]');
      const collectionLink = this.querySelector('[data-showcase-link]');
      if (!grid || !button || !collectionLink) return;
      this.dataset.enhanced = 'true';
      const extraCards = Array.from(grid.children).slice(4);
      if (!extraCards.length) return;
      extraCards.forEach(card => { card.hidden = true; });
      button.hidden = false;
      collectionLink.hidden = true;
      button.addEventListener('click', () => {
        extraCards.forEach(card => { card.hidden = false; });
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
        collectionLink.hidden = false;
        const firstLink = extraCards[0].querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: true });
        extraCards[0].scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }, { once: true });
    }
  });
}
